import {USER_ROOT_API_URL} from "../../../../config/settings.js"

export const GET_ALL_FRIENDS = USER_ROOT_API_URL + "/get_all_friends"
export const GET_FRIENDS_COUNT = USER_ROOT_API_URL + "/count_all_friends"
export const IS_USER_BLOCKED = USER_ROOT_API_URL + "/is_user_blocked"
export const GET_USER_HANDLENAME = USER_ROOT_API_URL + "/get_user_handlename"
